import { useEffect, useState } from "react";
import { api } from "./api";

export function useForfaits() {
  const [list, setList] = useState(null);
  useEffect(() => {
    api.get("/forfaits").then((r) => setList(r.data)).catch(() => setList([]));
  }, []);
  return list;
}
